import { customerApiClient } from './client'

const PUBLIC_PREFIX = '/api/public/customer'
const INTERNAL_PREFIX = '/api/internal/customer'

export type MeUser = {
  id: string
  is_active: boolean
  token?: string
  username: string
  is_staff?: boolean
  first_name: string
  last_name: string
  patronymic?: string
  email?: string
  delivery_address?: string
  phone?: string
  autofill_prompt_shown?: boolean
  arrival_site_notifications?: boolean
  arrival_email_notifications?: boolean
  primary_identity: string | null
  identities: string[]
}

export type LoginPayload = {
  phone: string
  password: string
}

export type RegisterPayload = LoginPayload & {
  first_name: string
  last_name: string
  patronymic?: string
  personal_data_consent: boolean
}

export type LinkPhonePayload = {
  phone: string
  password: string
}

export type UpdateMePayload = {
  first_name?: string
  last_name?: string
  patronymic?: string
  email?: string
  delivery_address?: string
  autofill_prompt_shown?: boolean
  arrival_site_notifications?: boolean
  arrival_email_notifications?: boolean
}

export const authApi = {
  login: (payload: LoginPayload) =>
    customerApiClient
      .post<MeUser>(`${PUBLIC_PREFIX}/login/phone/`, payload)
      .then((r) => r.data),

  register: (payload: RegisterPayload) =>
    customerApiClient
      .post<MeUser>(`${PUBLIC_PREFIX}/register/phone/`, payload)
      .then((r) => r.data),

  getMe: () =>
    customerApiClient.get<MeUser>(`${INTERNAL_PREFIX}/me/`).then((r) => r.data),

  updateMe: (payload: UpdateMePayload) =>
    customerApiClient.patch<MeUser>(`${INTERNAL_PREFIX}/me/`, payload).then((r) => r.data),

  linkPhone: (payload: LinkPhonePayload) =>
    customerApiClient.post<MeUser>(`${INTERNAL_PREFIX}/link/phone/`, payload).then((r) => r.data),
}
